import { render, staticRenderFns } from "./ArticleKitComponentForm.vue?vue&type=template&id=30c698d9&"
import script from "./ArticleKitComponentForm.vue?vue&type=script&lang=js&"
export * from "./ArticleKitComponentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports